export default {
  title: {
    en: 'FAMILY TIME!',
    it: 'FAMILY TIME'
  },

  description: {
    en: 'Welcome to Family Mode! Design your family crew and dive into the fun! Don\'t worry — you can switch things up later.',
    it: 'Benvenuto nel Family Mode. Crea i tuoi avatar e dai il via al divertimento insieme ai tuoi bambini.'
  },

  button: {
    en: 'Okay!',
    it: 'Ho Capito'
  }
};
